const names = [
  ['Aster Resin Fountain Pen','Fountain Pens',89,'Deep green resin body with a balanced fine nib.'],
  ['Lumen Brass Fountain Pen','Fountain Pens',128,'Brushed brass barrel with a smooth medium nib.'],
  ['Mistral Matte Fountain Pen','Fountain Pens',76,'Soft-touch charcoal finish for comfortable daily writing.'],
  ['Celadon Pocket Fountain Pen','Fountain Pens',68,'Compact celadon-green pen designed for notes on the move.'],
  ['Nocturne Piston Fountain Pen','Fountain Pens',148,'Ink-window piston filler with a midnight blue body.'],
  ['Roselle Acrylic Fountain Pen','Fountain Pens',98,'Rose-toned acrylic with subtle natural marbling.'],
  ['Harbour Blue Rollerball','Pens',64,'Blue lacquer rollerball with a precise metal tip.'],
  ['Graphite Twist Ballpoint','Pens',52,'Slim graphite ballpoint with a quiet twist mechanism.'],
  ['Ivory Desk Ballpoint','Pens',58,'Warm ivory barrel and polished gold-tone details.'],
  ['Sienna Mechanical Pencil','Pencils',49,'0.5 mm drafting pencil in a warm sienna finish.'],
  ['Cobalt Mechanical Pencil','Pencils',55,'Weight-balanced 0.7 mm pencil with knurled grip.'],
  ['Verdant Ink 50 ml','Ink',45,'Deep botanical green fountain pen ink with gentle shading.'],
  ['Harbour Ink 50 ml','Ink',45,'Saturated blue ink formulated for everyday paper.'],
  ['Mulberry Ink 50 ml','Ink',48,'Rich berry-purple ink with a clean, readable line.'],
  ['Amber Ink 50 ml','Ink',48,'Warm amber ink with expressive tonal variation.'],
  ['Nightfall Ink Set','Ink',72,'Five coordinated 15 ml inks for evening-inspired writing.'],
  ['Cotton Paper Notebook A5','Paper',46,'Thread-bound A5 notebook with 192 fountain-pen-friendly pages.'],
  ['Linen Journal B6','Paper',59,'B6 linen-bound journal with smooth ivory pages.'],
  ['Desk Notepad Grid','Paper',45,'A4 tear-off grid pad for planning and sketching.'],
  ['Correspondence Card Set','Paper',51,'Twenty-four heavyweight cards with matching envelopes.'],
  ['Walnut Pen Rest','Accessories',62,'Hand-finished walnut rest for two writing instruments.'],
  ['Canvas Pen Roll','Accessories',57,'Waxed canvas roll with six soft-lined pen slots.'],
  ['Leather Pen Sleeve','Accessories',69,'Vegetable-tanned leather sleeve with a secure flap.'],
  ['Glass Ink Well','Accessories',74,'Clear faceted glass well with a stable weighted base.'],
  ['Writer Gift Collection','Gift Sets',176,'A coordinated fountain pen, ink and notebook presentation set.']
];

export const products = names.map(([name, category, price, description], index) => ({
  id: index + 1,
  slug: name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, ''),
  name, category, price, description,
  image: `/assets/products/product-${String(index + 1).padStart(2, '0')}.jpg`,
  rating: 4.6 + (index % 4) / 10,
  reviews: 18 + index * 7,
  details: ['Designed by Gawiskbella', 'Quality checked in Singapore', 'Gift-ready recyclable packaging']
}));

export const categories = ['All', ...new Set(products.map((p) => p.category))];
